"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterNumber = void 0;
const core_1 = require("@apitable/core");
const react_1 = __importStar(require("react"));
const editor_number_1 = require("./editor/editor_number");
const styled_1 = require("./styled");
const FilterNumber = props => {
    const { value: _value, onChange: _onChange, field } = props;
    const value = (0, react_1.useMemo)(() => {
        const value = _value === null || _value === void 0 ? void 0 : _value[0];
        const numValue = Number(value);
        if (isNaN(numValue)) {
            return undefined;
        }
        if (field.type === core_1.FieldType.Percent) {
            return value == null ? value : String((0, core_1.times)(Number(value), 100));
        }
        return value;
    }, [_value, field.type]);
    const toolTip = (0, react_1.useMemo)(() => {
        switch (field.type) {
            case core_1.FieldType.Number:
                return (0, core_1.t)(core_1.Strings.number_cell_input_tips);
            case core_1.FieldType.Currency:
                return (0, core_1.t)(core_1.Strings.currency_cell_input_tips);
            case core_1.FieldType.Percent:
                return (0, core_1.t)(core_1.Strings.percent_cell_input_tips);
            default:
                return (0, core_1.t)(core_1.Strings.number_cell_input_tips);
        }
    }, [field.type]);
    const onChange = (_value) => {
        let value = _value;
        if (field.type === core_1.FieldType.Percent) {
            value = value == null ? '' : value;
            value = value === '' ? '' : String((0, core_1.divide)(Number(value), 100));
        }
        _onChange(value ? [value] : null);
    };
    return (react_1.default.createElement(styled_1.FilterInputWrap, null,
        react_1.default.createElement(editor_number_1.EditorNumber, { tooltip: toolTip, value: value, placeholder: ' ', onChange: onChange, validate: true })));
};
exports.FilterNumber = FilterNumber;
